import { Holiday } from "hooks/console/useConsoleHoliday";

// 날짜 상태 5종 — 영업일 / 주말(규칙) / 공휴일(api) / 수동 휴무 / 조기종료
export type DayState = "business" | "weekend" | "public" | "manual" | "early";

// 종료시간 선택지: 06:00 ~ 23:30, 30분 단위 (BE isValidTimeSlot 과 동일)
export const TIME_SLOTS: string[] = Array.from({ length: 36 }, (_, i) => {
    const minutes = 6 * 60 + i * 30;
    return `${String(Math.floor(minutes / 60)).padStart(2, "0")}:${minutes % 60 === 0 ? "00" : "30"}`;
});

export const NAME_MAX = 50;

// Date → 'YYYY-MM-DD' (로컬 달력 날짜 기준 — DayPicker 가 넘겨주는 자정 Date)
export const toDateStr = (date: Date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

// 오늘(KST) 'YYYY-MM-DD' — 브라우저 TZ 와 무관하게 서버 판정과 맞춘다
export const todayKst = () =>
    new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Seoul", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());

export const isWeekendStr = (dateStr: string) => {
    const dow = new Date(`${dateStr}T00:00:00Z`).getUTCDay();
    return dow === 0 || dow === 6;
};

export const getDayState = (dateStr: string, holiday?: Holiday): DayState => {
    if (holiday?.kind === "off") return holiday.source === "api" ? "public" : "manual";
    if (isWeekendStr(dateStr)) return "weekend";
    if (holiday?.kind === "early") return "early";
    return "business";
};

export const DAY_STATE_LABEL: Record<DayState, string> = {
    business: "영업일",
    weekend: "주말",
    public: "공휴일",
    manual: "수동 휴무",
    early: "조기종료",
};

// 셀 배경 / 강조 글자색 / 범례·점 색
export const DAY_STATE_STYLE: Record<DayState, { cell: string; text: string; dot: string }> = {
    business: { cell: "bg-white", text: "text-[#222222]", dot: "bg-transparent" },
    weekend: { cell: "bg-[#F7F7F7]", text: "text-[#999999]", dot: "bg-[#BBBBBB]" },
    public: { cell: "bg-[#FFF1F2]", text: "text-[#E11D48]", dot: "bg-[#E11D48]" },
    manual: { cell: "bg-[#FFF7ED]", text: "text-[#EA580C]", dot: "bg-[#EA580C]" },
    early: { cell: "bg-[#EFF6FF]", text: "text-[#2563EB]", dot: "bg-[#2563EB]" },
};

export const WEEKDAY_KO = ["일", "월", "화", "수", "목", "금", "토"];
